import './App.css';
import {BrowserRouter} from 'react-router-dom';
import {ReactKeycloakProvider} from "@react-keycloak/web";
import keycloak from "./Keycloak";
import {setToken, setUser} from "./services/AuthService";
import jwtDecode from "jwt-decode";
import Routing from "./routing/Routing";
import EventObserver from "./utils/EventObserver";
import {roles} from "./utils/reusableText";

function App() {
    const eventLogger = (event: unknown, error: unknown) => {
        console.log('onKeycloakEvent', event, error);
    }

    const tokenLogger = (tokens: unknown) => {
        console.log('onKeycloakTokens', tokens);

        const tokenDecoded = jwtDecode(tokens.token);
        setToken(tokens.token);

        const currentUser = {
            name: tokenDecoded.given_name,
            surname: tokenDecoded.family_name,
            email: tokenDecoded.email,
            role: tokenDecoded.realm_access?.roles.includes(roles.admin)? 'admin' : (
                tokenDecoded.realm_access?.roles.includes(roles.adminNoExport) ? 'adminNoExport' : (
                    tokenDecoded.realm_access?.roles.includes(roles.superAdmin) ? 'superAdmin' : undefined
                    )
                )
        }

        setUser(currentUser);

        // Dispatch keycloakReady only after token is stored
        EventObserver.dispatch('keycloakReady', {keycloakReady: true});
    }

    return (
        <BrowserRouter>
            <ReactKeycloakProvider authClient={keycloak} onEvent={eventLogger} onTokens={tokenLogger}
                                   initOptions={{onLoad: 'login-required'}}>
                <Routing/>
            </ReactKeycloakProvider>
        </BrowserRouter>
    );
}

export default App;
